/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ADDRESS } from '../programs';

/** InvalidInstructionData: Invalid instruction data */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_INSTRUCTION_DATA = 0x1770; // 6000
/** InvalidPayload: Invalid hook payload */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_PAYLOAD = 0x1771; // 6001
/** InvalidFeeSchedule: Invalid dynamic fee schedule */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE_SCHEDULE = 0x1772; // 6002
/** InvalidFee: Invalid swap fee */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE = 0x1773; // 6003
/** ArithmeticOverflow: Arithmetic overflow */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__ARITHMETIC_OVERFLOW = 0x1774; // 6004
/** InvalidAuthority: Invalid hook authority */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_AUTHORITY = 0x1775; // 6005
/** InvalidConfig: Invalid hook config */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_CONFIG = 0x1776; // 6006
/** InvalidCosigner: Invalid cosigner */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_COSIGNER = 0x1777; // 6007
/** CosignerAlreadyExists: Cosigner already exists */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_ALREADY_EXISTS = 0x1778; // 6008
/** CosignerNotFound: Cosigner not found */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_NOT_FOUND = 0x1779; // 6009
/** CosignerListFull: Cosigner list is full */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_LIST_FULL = 0x177a; // 6010
/** MissingAccount: Missing hook account */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__MISSING_ACCOUNT = 0x177b; // 6011
/** UnexpectedAccount: Unexpected hook account */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__UNEXPECTED_ACCOUNT = 0x177c; // 6012
/** InvalidLaunchContext: Invalid initializer launch context */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_LAUNCH_CONTEXT = 0x177d; // 6013
/** InvalidRehypeState: Invalid Rehype state */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_REHYPE_STATE = 0x177e; // 6014
/** SettlementIncomplete: Rehype settlement is incomplete */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__SETTLEMENT_INCOMPLETE = 0x177f; // 6015
/** CosignerRequired: Cosigner approval is required */
export const DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_REQUIRED = 0x1780; // 6016

export type DopplerLaunchHookV2Error =
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__ARITHMETIC_OVERFLOW
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_ALREADY_EXISTS
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_LIST_FULL
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_NOT_FOUND
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_REQUIRED
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_AUTHORITY
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_CONFIG
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_COSIGNER
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE_SCHEDULE
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_INSTRUCTION_DATA
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_LAUNCH_CONTEXT
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_PAYLOAD
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_REHYPE_STATE
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__MISSING_ACCOUNT
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__SETTLEMENT_INCOMPLETE
  | typeof DOPPLER_LAUNCH_HOOK_V2_ERROR__UNEXPECTED_ACCOUNT;

let dopplerLaunchHookV2ErrorMessages:
  | Record<DopplerLaunchHookV2Error, string>
  | undefined;
if (process.env.NODE_ENV !== 'production') {
  dopplerLaunchHookV2ErrorMessages = {
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__ARITHMETIC_OVERFLOW]: `Arithmetic overflow`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_ALREADY_EXISTS]: `Cosigner already exists`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_LIST_FULL]: `Cosigner list is full`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_NOT_FOUND]: `Cosigner not found`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__COSIGNER_REQUIRED]: `Cosigner approval is required`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_AUTHORITY]: `Invalid hook authority`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_CONFIG]: `Invalid hook config`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_COSIGNER]: `Invalid cosigner`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE]: `Invalid swap fee`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_FEE_SCHEDULE]: `Invalid dynamic fee schedule`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_INSTRUCTION_DATA]: `Invalid instruction data`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_LAUNCH_CONTEXT]: `Invalid initializer launch context`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_PAYLOAD]: `Invalid hook payload`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__INVALID_REHYPE_STATE]: `Invalid Rehype state`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__MISSING_ACCOUNT]: `Missing hook account`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__SETTLEMENT_INCOMPLETE]: `Rehype settlement is incomplete`,
    [DOPPLER_LAUNCH_HOOK_V2_ERROR__UNEXPECTED_ACCOUNT]: `Unexpected hook account`,
  };
}

export function getDopplerLaunchHookV2ErrorMessage(
  code: DopplerLaunchHookV2Error,
): string {
  if (process.env.NODE_ENV !== 'production') {
    return (
      dopplerLaunchHookV2ErrorMessages as Record<
        DopplerLaunchHookV2Error,
        string
      >
    )[code];
  }

  return 'Error message not available in production bundles.';
}

export function isDopplerLaunchHookV2Error<
  TProgramErrorCode extends DopplerLaunchHookV2Error,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ADDRESS,
    code,
  );
}
